// Copyright (c) 2023 Deere & Company

import t from 'tcomb';

const DuplicatePinPlateReport = t.struct({
	account: t.maybe(t.String),
	address1: t.maybe(t.String),
	address2: t.maybe(t.String),
	approvedBy: t.maybe(t.String),
	approverRemark: t.maybe(t.String),
	city: t.maybe(t.String),
	country: t.maybe(t.String),
	dateSubmmited: t.maybe(t.Number),
	factory: t.maybe(t.String),
	factoryName: t.maybe(t.String),
	id: t.maybe(t.String),
	instruction: t.maybe(t.String),
	machineModel: t.maybe(t.String),
	mailingRecipient: t.maybe(t.String),
	missingPlateReason: t.maybe(t.String),
	phone: t.maybe(t.String),
	pin: t.maybe(t.String),
	postalCode: t.maybe(t.String),
	requesterTCSM: t.maybe(t.String),
	shippingId: t.maybe(t.String),
	state: t.maybe(t.String),	
	status: t.maybe(t.String)

}, 'DuplicatePinPlateReport');

export const getDefaultState = () => new DuplicatePinPlateReport({
	account: '',
	address1: '',
	address2: '',
	approvedBy: '',
	approverRemark: '',
	city: '',
	country: '',
	dateSubmmited: null,
	factory: '',
	factoryName: '',
	id: '',
	instruction: '',
	machineModel: '',
	mailingRecipient: '',
	missingPlateReason: '',
	phone: '',
	pin: '',
	postalCode: '',
	requesterTCSM: '',
	state: '',	
	status: ''
   
});

export default DuplicatePinPlateReport;


// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate-report.js